
import { UNLIMITED_QUOTA } from '@/pages/Plan/config';
import { IUserPlan } from '@/types/dashboard';
export const getQuotaPerMonth = (userPlan: IUserPlan) => {
  const { quotaPerMonth, extraQuotaPerMonth } = userPlan;
  const isUnlimitedQuota = Number.isNaN(Number(quotaPerMonth)) || quotaPerMonth === UNLIMITED_QUOTA;
  return isUnlimitedQuota ? UNLIMITED_QUOTA : Number(quotaPerMonth) + extraQuotaPerMonth;
}

